import generatePicker from 'antd/es/date-picker/generatePicker';
import momentGenerateConfig from 'rc-picker/es/generate/moment';

// antd v5's default DatePicker is built for dayjs. This app uses moment
// everywhere (auction/lot dates, forms, API payloads), so a plain moment
// value passed to the stock DatePicker displays correctly on the input
// (since moment and dayjs share the same .format() API) but the calendar
// popup navigates to the wrong month/year when opened, because the panel
// relies on generateConfig methods that don't recognize a moment instance.
// Building the picker with rc-picker's moment generateConfig fixes that.
const DatePicker = generatePicker(momentGenerateConfig);

export default DatePicker;
